<template>
	<v-sheet class="manager-header" color="headerPrimary">
		<a :href="logoLink" target="_blank">
			<img class="manager-header-logo" alt="Captura Yearbooks" :src="logo">
		</a>

		<div class="manager-header-name">{{ user.name }}</div>
	</v-sheet>
</template>

<script>
export default {
	props: {
		user: {},
		logo: {
			default: '/css/images/logo.png'
		},
		logoLink: {
			default: null
		}
	}
};
</script>

<style scoped>
.manager-header {
	padding: 1em;
}

.manager-header .manager-header-logo {
	width: 100%;
	max-height: 84%;
}

.manager-header .manager-header-name {
	color: white;
}
</style>